"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

var _timeZoneList = require('shared/services/timeZoneList');

// Wall-clock times in a named (IANA) time zone, without a time zone library:
// Intl knows every zone's rules, and these turn a zone's calendar and clock
// into an instant and back.














const FALLBACK_ZONE = 'UTC'
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']


// The zone the device's clock is in.
 const deviceTimeZone = () => {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return exports.isTimeZone.call(void 0, zone) ? zone : FALLBACK_ZONE
  } catch (e) {
    return FALLBACK_ZONE
  }
}; exports.deviceTimeZone = deviceTimeZone

// One formatter per zone: building them is the slow part.
const formatters = new Map()
const partsFormatter = (timeZone) => {
  let formatter = formatters.get(timeZone)
  if (!formatter) {
    formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      hourCycle: 'h23',
      weekday: 'short',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    })
    formatters.set(timeZone, formatter)
  }
  return formatter
}

// A zone this engine knows. Its formatter is the one wallClock uses, so
// checking costs nothing later.
 const isTimeZone = (timeZone) => {
  if (typeof timeZone !== 'string' || !timeZone) return false
  try {
    return !!partsFormatter(timeZone)
  } catch (e2) {
    return false
  }
}; exports.isTimeZone = isTimeZone

// What a clock in the zone reads at the instant.
 const wallClock = (date, timeZone) => {
  const parts = {}
  partsFormatter(timeZone).formatToParts(date).forEach(({ type, value }) => { parts[type] = value })
  return {
    year: Number(parts.year),
    month: Number(parts.month),
    day: Number(parts.day),
    // Some engines write midnight as 24 even with h23.
    hour: Number(parts.hour) % 24,
    minute: Number(parts.minute),
    weekday: WEEKDAYS.indexOf(_nullishCoalesce(parts.weekday, () => ( ''))),
  }
}; exports.wallClock = wallClock

// The wall time as if it were UTC: plain calendar arithmetic, with no
// daylight saving in the way.
const asUtc = ({ year, month, day, hour, minute }) => Date.UTC(year, month - 1, day, hour, minute)

const DAY_FIELDS = ['year', 'month', 'day'] 
const TIME_FIELDS = [...DAY_FIELDS, 'hour', 'minute'] 

const sameWallTime = (a, b) => TIME_FIELDS.every(field => a[field] === b[field])

// How far the zone's clock is ahead of UTC at the instant, in ms.
const offsetAt = (instant, timeZone) => {
  const seconds = instant % 60000
  return asUtc(exports.wallClock.call(void 0, new Date(instant - seconds), timeZone)) - (instant - seconds)
}

/* The instant a clock in the zone reads the wall time, or null when it never
 * does (the clocks skip it going forward). A time it reads twice (clocks
 * going back) is the first. */
 const zonedInstant = (wall, timeZone) => {
  const guess = asUtc(wall)
  if (Number.isNaN(guess)) return null
  const candidates = [offsetAt(guess, timeZone), offsetAt(guess - 24 * 60 * 60 * 1000, timeZone),
    offsetAt(guess + 24 * 60 * 60 * 1000, timeZone)]
    .map(offset => guess - offset)
    .filter(instant => sameWallTime(exports.wallClock.call(void 0, new Date(instant), timeZone), wall))
    .sort((a, b) => a - b)
  return candidates.length ? new Date(candidates[0]) : null
}; exports.zonedInstant = zonedInstant

// A calendar date some days after the wall clock's, at the given time.
 const daysAfter = (wall, days, hour, minute = 0) => {
  const date = new Date(Date.UTC(wall.year, wall.month - 1, wall.day + days))
  return { year: date.getUTCFullYear(), month: date.getUTCMonth() + 1, day: date.getUTCDate(), hour, minute }
}; exports.daysAfter = daysAfter

 const sameWallDay = (a, b) => DAY_FIELDS.every(field => a[field] === b[field]); exports.sameWallDay = sameWallDay

// The instant's wall time in the zone with a moment format ("ddd h:mm A").
 const formatInZone = (date, timeZone, format) =>
  _moment2.default.utc(asUtc(exports.wallClock.call(void 0, date, timeZone))).format(format); exports.formatInZone = formatInZone

// "2026-10-15T14:30", what a datetime-local field holds, for the instant in the zone.
 const toWallValue = (date, timeZone) => exports.formatInZone.call(void 0, date, timeZone, 'YYYY-MM-DDTHH:mm'); exports.toWallValue = toWallValue

// A datetime-local value ("2026-10-15T14:30") as a wall time, or null.
 const fromWallValue = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value)
  if (!match) return null
  const [year, month, day, hour, minute] = match.slice(1).map(Number) 
  return { year, month, day, hour, minute }
}; exports.fromWallValue = fromWallValue

// A device-local Date whose clock reads what the zone's does at the instant,
// to the minute: for native pickers, which only know the device's zone.
 const wallAsLocalDate = (date, timeZone) => {
  const { year, month, day, hour, minute } = exports.wallClock.call(void 0, date, timeZone)
  return new Date(year, month - 1, day, hour, minute)
}; exports.wallAsLocalDate = wallAsLocalDate

const nameFormatters = new Map()
const nameFormatter = (timeZone) => {
  let formatter = nameFormatters.get(timeZone)
  if (!formatter) {
    formatter = new Intl.DateTimeFormat('en-US', { timeZoneName: 'short', timeZone })
    nameFormatters.set(timeZone, formatter)
  }
  return formatter
}

// "GMT+9", "GMT+5:30", "GMT-3" or "GMT": the zone's offset at the instant.
const gmtOffset = (date, timeZone) => {
  const minutes = Math.round(offsetAt(Math.floor(date.getTime() / 60000) * 60000, timeZone) / 60000)
  if (!minutes) return 'GMT'
  const hours = Math.floor(Math.abs(minutes) / 60)
  const rest = Math.abs(minutes) % 60
  return `GMT${minutes < 0 ? '-' : '+'}${hours}${rest ? `:${String(rest).padStart(2, '0')}` : ''}`
}

/* "PDT" for the zone at that instant; a zone en-US has no letters for reads
 * "GMT+5:30". Hermes on iOS calls every such zone plain "GMT", so a GMT-style
 * name is always worked out here. */
 const zoneAbbreviation = (date, timeZone = exports.deviceTimeZone.call(void 0, )) => {
  try {
    const name = _nullishCoalesce(_optionalChain([nameFormatter, 'call', _ => _(timeZone)
, 'access', _2 => _2.formatToParts, 'call', _3 => _3(date)
, 'access', _4 => _4.find, 'call', _5 => _5(part => part.type === 'timeZoneName'), 'optionalAccess', _6 => _6.value]), () => ( ''))
    return name && !/^(GMT|UTC)/.test(name) ? name : gmtOffset(date, timeZone)
  } catch (e3) {
    return ''
  }
}; exports.zoneAbbreviation = zoneAbbreviation

// US zones first, by the names staff know them by.
const COMMON_ZONES = [
  { id: 'America/New_York', name: 'Eastern Time (ET)' },
  { id: 'America/Chicago', name: 'Central Time (CT)' },
  { id: 'America/Denver', name: 'Mountain Time (MT)' },
  { id: 'America/Los_Angeles', name: 'Pacific Time (PT)' },
  { id: 'America/Anchorage', name: 'Alaska Time (AKT)' },
  { id: 'Pacific/Honolulu', name: 'Hawaii Time (HT)' },
  { id: 'America/Phoenix', name: 'Arizona Time (MST)' },
]
const COMMON_NAMES = new Map(COMMON_ZONES.map(zone => [zone.id, zone.name]))

// "Europe/London" → "London", "America/Argentina/Buenos_Aires" → "Buenos Aires".
const placeName = (timeZone) => (timeZone.split('/').pop() || timeZone).replace(/_/g, ' ')

/* What staff read for a zone: "Pacific Time (PT)" for the US zones, else
 * "London time (BST)", with the letters for that instant. */
 const timeZoneName = (timeZone, at = new Date()) => {
  const common = COMMON_NAMES.get(timeZone)
  if (common) return common
  if (timeZone === FALLBACK_ZONE) return 'UTC'
  const abbreviation = exports.zoneAbbreviation.call(void 0, at, timeZone)
  return abbreviation ? `${placeName(timeZone)} time (${abbreviation})` : `${placeName(timeZone)} time`
}; exports.timeZoneName = timeZoneName








/* Every zone to pick from: the US zones, then the device's own if it isn't
 * one of them, then the rest A to Z by id. The list is bundled, not read from
 * Intl.supportedValuesOf, which Hermes lacks, so web and mobile list the same. */
 const timeZoneChoices = (device = exports.deviceTimeZone.call(void 0, ), at = new Date()) => {
  const ids = [...COMMON_ZONES.map(zone => zone.id)]
  const add = (id) => { if (!ids.includes(id) && exports.isTimeZone.call(void 0, id)) ids.push(id) }
  add(device)
  _timeZoneList.ALL_TIME_ZONES.forEach(add)
  return ids.map((id) => {
    const name = exports.timeZoneName.call(void 0, id, at)
    return { id, name, searchText: `${name} ${id.replace(/_/g, ' ')}`.toLowerCase() }
  })
}; exports.timeZoneChoices = timeZoneChoices

// The choices whose name or id has every word typed.
 const filterTimeZoneChoices = (choices, query) => {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean)
  return words.length ? choices.filter(choice => words.every(word => choice.searchText.includes(word))) : choices
}; exports.filterTimeZoneChoices = filterTimeZoneChoices
